import { IdoInstance } from 'src/models/idoList';
import { IdoListViewColumn } from 'src/models/idoList/fieldTypes';

import { decodeBase64 } from 'src/util/common';
import { Callback } from 'src/util/query/models/Callback';

import { IdoListCallbackStoreContract } from '../interfaces';

const FALLBACK_INSTANCE_COLOR = '#f5f5f5';

export class GetTheIdoInstancesCallBack extends Callback<IdoInstance[]> {
	public constructor(private readonly store: IdoListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse?: unknown): void => {
		console.error('[IDO INSTANCES] Fehler beim Laden der Instanzen:', {
			error: failureResponse,
			timestamp: new Date().toISOString(),
		});
	};

	successCallbackFunction = (successResponse: IdoInstance[]): void => {
		const idoInstanceFieldList = new Map<string, IdoListViewColumn[]>();

		const validatedInstances = successResponse.map((instance) => {
			if (!instance.Color) {
				const fallbackColors = ['#2196f3', '#4caf50', '#ff9800', '#f44336', '#9c27b0', '#00bcd4'];
				const colorIndex = parseInt(instance.ID) % fallbackColors.length;
				instance.Color = fallbackColors[colorIndex] || FALLBACK_INSTANCE_COLOR;
			}
			return instance;
		});

		this.store.setIdoInstanceList(validatedInstances);
		validatedInstances.forEach((idoInstance) => {
			idoInstanceFieldList.set(
				idoInstance.ID,
				JSON.parse(decodeBase64(idoInstance.columnDefinitionJSON)) as IdoListViewColumn[]
			);
		});
		this.store.setIdoInstanceFieldList(idoInstanceFieldList);
	};
}
